/**
 * The town's music, its switch: "Town music" in home's ⋯ menu, on by default, on this device only (localStorage).
 * "Sounds and vibration" off (`feel.ts`) silences it too. The music itself is `music/town-music.ts`, loaded with
 * home's town; its sound (`music/engine.ts`, with Tone.js) loads on the first tap with the music on.
 */
import { feelOn } from './feel';

const KEY = 'li-music';
/** Sent on `window` when either switch changed. */
export const MUSIC_CHANGED = 'li-music-changed';

/** Whether the town's music is on for this device: on unless the learner turned it off. */
export function musicOn(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'off';
  } catch {
    return true;
  }
}

/** The music may play: its own switch and the sounds' are both on. */
export const musicWanted = (): boolean => musicOn() && feelOn();

/** A switch changed ("Town music", or "Sounds and vibration"): the music follows at once. */
export function musicChanged(): void {
  window.dispatchEvent(new Event(MUSIC_CHANGED));
}

export function setMusic(on: boolean): void {
  try {
    if (on) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, 'off');
  } catch { /* private mode: the switch holds for this page only */ }
  musicChanged();
}
